// @flow

import IframeChallenge from './IframeChallenge';

class SAPExchangeMediaChallenge extends IframeChallenge {
    iFrameSource() {
        const tagId = this.props.challenge.placement;
        const width = this.props.challenge.width;
        const height = this.props.challenge.height;

        return `/sapxm.html?tag=${tagId}&width=${width}&height=${height}`;
    }

    componentDidMount() {
        this.setState({ loading: false });
        this.eventReady();
        this.showSkipButtonWithTimeout(5000);
    }

    eventReady() {
         super.eventReady();
         this.trackImpression(() => {});
         this.trackAdOpportunity(true);         
    }
}

export default SAPExchangeMediaChallenge;



// WEBPACK FOOTER //
// ./src/campaign/challenges/external-sdks/SAPExchangeMediaChallenge.jsx